import { render, staticRenderFns } from "./full.vue?vue&type=template&id=5fc56ec9&scoped=true&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"
import style0 from "./full.vue?vue&type=style&index=0&id=5fc56ec9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc56ec9",
  null
  
)

export default component.exports